import { render, staticRenderFns } from "./LecturersModal.vue?vue&type=template&id=c578a8ac&scoped=true&"
import script from "./LecturersModal.vue?vue&type=script&lang=js&"
export * from "./LecturersModal.vue?vue&type=script&lang=js&"
import style0 from "./LecturersModal.vue?vue&type=style&index=0&id=c578a8ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c578a8ac",
  null
  
)

export default component.exports